export const getFirstOrSecond = (mainText?: string, secondText?: string) => {
  // eslint-disable-next-line no-extra-boolean-cast
  return !!mainText ? mainText : (secondText ?? '');
};
